import "./Main.css";
import imagem from "../../Assets/img/ClickMe.png";
import { useState } from "react";
import { useHistory } from "react-router-dom";

const Home = () => {
  const [active, setActive] = useState(false);
  const history = useHistory();

  const setActiveClass = () => {
    setActive(!active);
  };

  return (
    <div className="containerHome">
      <div className="logo">
        <div
          onClick={() => setActiveClass()}
          className={!active ? "img-home" : "img-home active"}
        >
          <span className="roda">
            <a
              href="https://github.com/anthonifelipi"
              target="_blank"
              rel="noopener noreferrer"
            >
              github
            </a>
          </span>
          <span className="roda">
            <button onClick={() => history.push("/aboutme")}>About</button>
          </span>
          <span className="roda">
            <a
              href="https://www.linkedin.com/in/anthoni-felipi/"
              target="_blank"
              rel="noopener noreferrer"
            >
              linkdin
            </a>
          </span>
          <span className="roda">
            <button onClick={() => history.push("/techs")}>Techs</button>
          </span>
        </div>
        <div className="tesste"></div>
        <img src={imagem} alt="um imagem com a escrita 'click me'" />
      </div>
    </div>
  );
};

export default Home;
